export const $customSet = (obj:any, key:any, value:any) => {
	if (obj[key] !== value) {
		obj[key] = value
	}
}